import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import ImageOrFlag from "../Common/MatchSideImageOrFlag.jsx";
import Details from "./MatchDetails.jsx";
import HighlightableText from "../Common/HighlightableText.jsx";
//import CSSTransitionGroup from "react-addons-css-transition-group";
import { withMarkedSportsmen } from "../Results/MarkedSportsen/withMarkedSportsmen";
import AchievementDetailsModal from "../TeamDetails/Components/Modal/AchievementDetailsModal.jsx";
import useYearGameAchievementsFormatter from "../utils/useYearGameAchievementsFormatter.js";

const CSSTransitionGroup = ({ children }) => {
  //todo: use transition group instead
  return children;
};

const Calendar = ({
  matches,
  loading,
  show,
  onClick,
  onDetailsClick,
  details,
  gameId,
  onDetailsClose,
  isMarkedMatchSide,
  sportId,
  gameType,
  rankingClassificationId,
}) => {
  if (!matches || !show) return null;
  if (loading) {
    return <FormattedMessage id="calendar.loading" />;
  }

  const {
    formattedAchievements,
    setAchievements,
    formattedTypes,
    setTypes,
    fetchFromMatch,
    usesNabps,
    fetchNabpsDetails
  } = useYearGameAchievementsFormatter(gameId);
  
  useEffect(() => {
    fetchNabpsDetails(sportId, gameType);
  }, []);
  
  const [selectedSides, setSelectedSides] = useState(null);

  const viewAchievementScores = async(sportsmanA, sportsmanB, rankingClassificationId, submatchId, match) => {
    if (match.score) {
      sportsmanA['details'] = (match['score']['sideA']).toString();
      sportsmanB['details'] = (match['score']['sideB']).toString();
    }

    fetchFromMatch(sportsmanA.id, sportsmanB.id, rankingClassificationId, submatchId, sportId);

    setSelectedSides({sideA: sportsmanA, sideB: sportsmanB});
  }

  const onAchievementsDetailsClose = () => {
    setAchievements(null);
    setTypes([]);
    setSelectedSides(null);
  }

  return (
    <div className="match-calendar">
      <FormattedMessage id="calendar.title">
        {(message) => (
          <Panel name={message}>
            <table className="zw-table zw-table--dark-striped">
              {matches
                .filter((match) => !!match.score)
                .map((match) => (
                  <Match
                    key={match.id}
                    {...match}
                    isMarkedMatchSide={isMarkedMatchSide}
                    onDetailsClick={onDetailsClick}
                    onClick={() => 
                      usesNabps ? viewAchievementScores(match['sideA'], match['sideB'], rankingClassificationId, 0, match) : onClick(gameId, match.id)}
                  />
                ))}
              {matches
                .filter((match) => !match.score)
                .map((match) => (
                  <Match
                    key={match.id}
                    {...match}
                    isMarkedMatchSide={isMarkedMatchSide}
                    onClick={() => usesNabps ? viewAchievementScores(match['sideA'], match['sideB'], rankingClassificationId, 0, match) : onClick(gameId, match.id)}
                  />
                ))}
              <tbody>
                <tr>
                  <td colSpan="2">
                    <FinishedStar finished />
                    {" - "}
                    <FormattedMessage id="calendar.finished" />
                  </td>
                </tr>
              </tbody>
            </table>
          </Panel>
        )}
      </FormattedMessage>
      <CSSTransitionGroup
        transitionName="transition-fade"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {details ? (
          <>
            { usesNabps
              ? 
              <AchievementDetailsModal 
                key="1" 
                achievements={formattedTypes}
                details={formattedAchievements} 
                game={''}
                onClose={onAchievementsDetailsClose}
                isSingleSportsman={false}
                sidesDetails={selectedSides}
                sportType={sportId}
              />
              : <Details key="1" {...details} onClose={onDetailsClose} />
            }
          </>
        ) : (
          usesNabps ? 
            <AchievementDetailsModal 
              key="1" 
              achievements={formattedTypes}
              details={formattedAchievements} 
              game={''}
              onClose={onAchievementsDetailsClose}
              isSingleSportsman={false}
              sidesDetails={selectedSides}
              sportType={sportId}
            />
            : null
        )}
      </CSSTransitionGroup>
    </div>
  );
};

const FinishedStar = ({ finished }) =>
  !finished ? null : (
    <FormattedMessage id="calendar.finished">
      {(msg) => (
        <span
          title={msg}
          className="glyphicon glyphicon-star match-calendar__star"
        />
      )}
    </FormattedMessage>
  );

const Panel = ({ name, children }) => (
  <section className="module">
    <header className="module__header">
      <h2 className="module__title">{name}</h2>
    </header>
    {children}
  </section>
);

const Match = ({
  score,
  sideA,
  sideB,
  startsOn,
  finished,
  onClick,
  onDetailsClick,
  isMarkedMatchSide,
  formattedPartsResults,
}) => (
  <tbody
    role="button"
    className={`calendar-match ${
      score ? "calendar-match--score" : null
    } zw-tooltip__trigger`}
    onClick={score && onClick}
  >
    <tr className="">
      <th>
        {formattedPartsResults ? (
          <div className="zw-tooltip">
            <div className="zw-tooltip__content">{formattedPartsResults}</div>
          </div>
        ) : null}
        {startsOn}
      </th>
      <th>
        <FinishedStar finished={finished} />
      </th>
    </tr>
    <CalendarMatchSide
      side={sideA}
      marked={isMarkedMatchSide(sideA)}
      score={score && score.sideA}
      formattedPartsResults={formattedPartsResults}
      onDetailsClick={onDetailsClick}
    />
    <CalendarMatchSide
      side={sideB}
      marked={isMarkedMatchSide(sideB)}
      score={score && score.sideB}
      formattedPartsResults={formattedPartsResults}
      onDetailsClick={onDetailsClick}
    />
  </tbody>
);

const CalendarMatchSide = ({ side, marked, score, onDetailsClick }) => (
  <tr>
    <td>
      <ImageOrFlag side={side} />
      {` `}
      <HighlightableText active={marked}>{side.name}</HighlightableText>
    </td>
    <td
      onClick={(e) => {
        if (score === null || score === undefined) return;
        e.stopPropagation();
        onDetailsClick(side.id);
      }}
      style={{ cursor: "pointer", color: "#82bc3d", fontWeight: "bold" }}
    >
      {score}
    </td>
  </tr>
);

export default withMarkedSportsmen(Calendar);
